$(document).ready(function(){
    $(".generalmessage").prependTo(".header");
//prepend general message into header
if ( $("body").hasClass("generalMessageOn") ) {
            $(".generalmessage").prependTo(".header");
     }

// footer logo
$('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');


// Append
if ($(window).width() < 801) {
$('.standAloneDirections').prependTo('.right-content');
} else {
     $('.standAloneDirections').insertAfter('#weatherBugWidget');
}

//parallax
var isIE = /*@cc_on!@*/false || !!document.documentMode;
if(!isIE){
  setTimeout(function() {
      $('.slider-main').parallax({imageSrc: 'https://cdn.saffire.com/images.ashx?t=ig&rid=LebanonAreaFair&i=slider-bg(1).jpg'});
  }, 500);
}else{
      $('.slider-main').addClass('notParallex');
}
});

$(window).load(function(){
$('body').addClass('pageIsLoaded');


// Append
setTimeout(function() {
if ($(window).width() < 801) {
$('.countdown-main').insertAfter('.slider-main');
} else {
     $('.countdown-main').appendTo('.header .headerInnerContent');
}
}, 1000);
});

$(window).resize(function(){



// Append
if ($(window).width() < 801) {
$('.countdown-main').insertAfter('.slider-main');
} else {
     $('.countdown-main').appendTo('.header .headerInnerContent');
}

if ($(window).width() < 801) {
$('.standAloneDirections').prependTo('.right-content');
} else {
 $('.standAloneDirections').insertAfter('#weatherBugWidget');
}
});
